import 'css-chunksrc/client/pages/projectPage/timeSheetPage/month/styles.scss';export default {
  "month": "_month_1isar_1",
  "name": "_name_1isar_11",
  "week": "_week_1isar_18"
};